export default class TaskMedium {
  public type: string;
  public url: string;
  public embedUrl?: string;

  constructor(data: Partial<TaskMedium>) {
    this.type = data.type || "";
    this.url = data.url || "";

    if (this.type === "vimeo") {
      const match = this.url.match(/vimeo\.com\/(\d+)/);

      if (match) {
        this.embedUrl = `https://player.vimeo.com/video/${match[1]}?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media`;
      }
    } else if (this.type === "youtube") {
      const match = this.url.match(/v=(\w+)/);

      if (match) {
        this.embedUrl = `https://www.youtube.com/embed/${match[1]}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`;
      }
    }
  }
}
